import React from "react";
import { FormSpy } from "react-final-form";
import { FieldArray } from "react-final-form-arrays";
import { Col, Table } from "reactstrap";
import RadioButton from "src/components/Form/RadioButtonV2/RadioButton";
import SimpleDatePickerField from "src/components/Form/SimpleDatePickerFieldV2/SimpleDatePickerField";
import TypeaheadFieldV2 from "src/components/Form/TypeaheadFieldV2/TypeaheadFieldV2";
import CustomIcon, { IconName } from "src/components/Icon/Icon";
import * as S from "src/constants/StringConstants";
import "./BrokerAffiliatesTable.scss";

const BrokerAffiliatesTable = ({ form, values, affiliateList, dropdownOptions }) => {
  return (
    <>
      <Table bordered className="broker-affiliates-table">
        <thead>
          <tr>
            <th>{S.BRO_AFFILIATE_IS_PRIMARY}</th>
            <th>{S.BRO_AFFILIATE_AFFILIATE}</th>
            <th>{S.BRO_AFFILIATE_START_DATE}</th>
            <th>{S.BRO_AFFILIATE_END_DATE}</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          <FieldArray name="brokerAffiliates">
            {({ fields }) =>
              fields.map((name, index) =>
                fields.value[index].affiliateRemovedByUser ? null : (
                  <tr key={`${index}/${fields.length}`}>
                    <td className="radio-small-wrapper">
                      <RadioButton
                        name="affiliateID"
                        value={fields.value[index].affiliate?.value}
                        disabled={!fields.value[index].affiliate?.value}
                        label=""
                        onChange={affiliateID => {
                          const affiliateData = dropdownOptions.affiliateList.find(x => x.value === affiliateID);
                          try {
                            form.change("branchTypeID", affiliateData.branchTypeID);
                            form.change("affiliateID", affiliateID);
                          } catch (e) {
                            console.log("exception:", e);
                          }
                        }}
                      />
                    </td>

                    <td>
                      <FormSpy subscription={{ values: true }}>
                        {({ values }) => {
                          const selectedAffiliate = values.brokerAffiliates?.[index];
                          const selectedAffiliateValue = selectedAffiliate?.affiliate || null;

                          const selectedCompanyID = values.companyID;
                          const companyData = dropdownOptions.companyList.find(c => c.value === selectedCompanyID);
                          const companyAffiliateID = companyData?.affiliateId || null;

                          const isAutoFillRequired =
                            !selectedAffiliateValue && companyAffiliateID && !selectedAffiliate?.isManuallyEdited;

                          if (isAutoFillRequired) {
                            form.change(
                              `${name}.affiliate`,
                              affiliateList.find(a => a.value === companyAffiliateID) || null,
                            );
                          }

                          return (
                            <TypeaheadFieldV2
                              name={`${name}.affiliate`}
                              label=""
                              options={affiliateList}
                              selected={affiliateList.find(a => a.value === selectedAffiliateValue?.value) || null}
                              onChange={v => {
                                if (!v || v.length === 0) {
                                  form.change(`${name}.affiliate`, undefined);
                                  form.change(`${name}.isManuallyEdited`, true);
                                } else {
                                  form.change(`${name}.affiliate`, v[0]);
                                  form.change(`${name}.isManuallyEdited`, true);
                                }
                              }}
                            />
                          );
                        }}
                      </FormSpy>
                    </td>
                    <td>
                      <SimpleDatePickerField name={`${name}.startDate`} isFormMode />
                    </td>
                    <td>
                      <SimpleDatePickerField name={`${name}.endDate`} isFormMode />
                    </td>
                    <td>
                      <button
                        className="remove-affiliate-btn"
                        disabled={fields.value[index].affiliate?.value === values.affiliateID}
                        onClick={() => {
                          fields.update(index, {
                            ...values.brokerAffiliates[index],
                            affiliateRemovedByUser: true,
                          });
                        }}>
                        <CustomIcon name={IconName.DeleteFileGold} size="16px" />
                      </button>
                    </td>
                  </tr>
                ),
              )
            }
          </FieldArray>
          <tr>
            <td>
              <RadioButton
                name="affiliateID"
                value={""}
                label=""
                onChange={affiliateID => {
                  form.change("affiliateID", affiliateID);
                }}
              />
            </td>
            <td>
              <span className="no-affiliate-text">{S.BRO_AFFILIATE_NONE}</span>
            </td>
          </tr>
        </tbody>
      </Table>

      <Col className="d-flex align-items-center justify-content-end gap-3">
        <button
          type="button"
          className="button-v2 button-v2__white button-v2__secondary-mini"
          onClick={() => form.mutators.push("brokerAffiliates", {})}>
          <span>{S.BRO_AFFILIATE_ADD_BUTTON}</span>
        </button>
      </Col>
    </>
  );
};

export default BrokerAffiliatesTable;
